import { StepEnum } from '@crm/api'
import { AppLink } from '@crm/components'
import { ImportFormFooter } from '@crm/features/leads/components'
import { paths } from '@crm/routes'
import { Route } from '@crm/types'
import { TitleSection } from '@shared/components'
import { useLocales } from '@shared/locales'
import { Card, Steps } from 'antd'
import { useParams } from 'react-router-dom'

type Props = {
  step: string
  steps: Route[]
  children?: React.ReactNode
}

export const ImportLayout = ({ step, steps, children }: Props) => {
  const { t } = useLocales()
  const { id } = useParams()

  const stepList = Object.values(StepEnum)
  const activeIndex = stepList.findIndex((i) => i === step)
  const prevStep = stepList[activeIndex - 1] || 'first'
  const backLink = id
    ? paths.leadImport.item(id, prevStep)
    : `/leads/import/${prevStep}`

  return (
    <>
      <TitleSection title={t(`import.contact`)} />

      <Steps
        responsive
        current={activeIndex + 1}
        items={steps?.map((step, index) => ({
          key: step?.path,
          title:
            index <= activeIndex + 1 ? (
              <AppLink
                to={paths.leadImport.item(
                  id?.toString() || '',
                  step?.path || ''
                )}
              >
                {t(`import.${step?.path}`)}
              </AppLink>
            ) : (
              t(`import.${step?.path}`)
            )
        }))}
      />
      <Card className="mt-20">
        {children}
        <ImportFormFooter
          formName={`form-${step}`}
          backLink={backLink}
          disabledBackLink={step === 'first'}
          directionNav={step !== StepEnum.START_IMPORT}
          importButton={step === StepEnum.START_IMPORT}
        />
      </Card>
    </>
  )
}
